/**
 * Central dictionary for normalizing backend labels into human-readable display names.
 * Keys are lowercase and normalized (collapsed spaces) for robust matching.
 */
export const LABEL_MAP: Record<string, string> = {
    // Exact match products
    "withinday": "WD",
    "within-day": "WD",
    "withinday3h": "WD",
    "intraday": "WD",
    "dayahead": "DA",
    "day-ahead": "DA",
};

/**
 * Substring replacements for messy market names / sources.
 * These are processed in order.
 */
const REGEX_REPLACEMENTS: { pattern: RegExp; replacement: string }[] = [
    { pattern: /TTF Hi(\s+)?Cal(\s+)?51\.6/gi, replacement: "TTF" },
    { pattern: /TTF Hi(\s+)?Cal/gi, replacement: "TTF" },
    { pattern: /NBP Spot/gi, replacement: "NBP" },
    { pattern: /THE Hi(\s+)?Cal/gi, replacement: "THE" },
    { pattern: /THE Low(\s+)?Cal/gi, replacement: "THE L" },
    { pattern: /CEGH VTP/gi, replacement: "CEGH" },
];



/**
 * Normalizes a label using the central mapping and regex replacements.
 */
export function normalizeLabel(label: string | null | undefined): string {
    if (!label) return "";

    let text = String(label);

    // 1. Apply regex replacements (substrings)
    for (const { pattern, replacement } of REGEX_REPLACEMENTS) {
        text = text.replace(pattern, replacement);
    }

    // 2. Collapse whitespace and check exact matches for the whole string
    const normalizedKey = text.toLowerCase().replace(/\s+/g, ' ').trim();
    if (LABEL_MAP[normalizedKey]) {
        return LABEL_MAP[normalizedKey];
    }

    return text;
}
